module.exports = __webpack_public_path__ + "static/media/bg.37270538.png";